import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { ImageUplaod } from '../../components/ImageUpload';
import { Labeled } from '../../components/Labeled';
import { TextField } from '../../components/TextField';
import { Toggle } from '../../components/Toggle';
import { api } from '../../plugins/axios';
import { Editor } from '../../plugins/froala';
import { Seminar } from '../../types';
import { AdminH1 } from '../components/AdminH1';

export const SeminarsAdd = () => {
  const { push } = useHistory();
  const [title, setTitle] = useState('');
  const [thumbnail, setThumbnail] = useState<File | null>(null);
  const [context, setContext] = useState('');
  const [isHide, setHide] = useState(false);

  async function add() {
    const seminarData: any = {
      title,
      context,
      isHide,
    };
    if (thumbnail) {
      const formData = new FormData();
      formData.append('file', thumbnail);
      const { data: url } = await api.post('/s3/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      seminarData.thumbnail = url;
    }
    const { data: seminar } = await api.post<Seminar>(
      `/admin/seminars`,
      seminarData,
    );
    push(`/admin/seminars/${seminar.id}`);
  }

  return (
    <>
      <AdminH1>Seminar</AdminH1>

      <Card>
        <div className="space-y-6 px-4 py-6 sm:px-6 md:px-8">
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <ImageUplaod
            label="Thumbnail"
            file={thumbnail}
            onChange={(e) =>
              e.target.validity.valid &&
              e.target.files &&
              setThumbnail(e.target.files.item(0))
            }
          />

          <Labeled label="Content">
            <Editor onModelChange={(model: any) => setContext(model)} />
          </Labeled>
          <div className="px-4 py-6 sm:px-6 md:px-8">
            <div className="flex space-x-2">
              <span>IsHide</span>
              <Toggle onChange={() => setHide(!isHide)} checked={isHide} />
              <p className="text-gray-400">숨김 활성화 여부</p>
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-4 px-4 py-4 sm:px-6 md:px-8">
          <Button
            text="Cancel"
            to={`/admin/seminars`}
            className="h-10 text-sm outlined-gray-800 hover:bg-gray-50"
          />
          <Button
            text="Add"
            className="h-10 text-sm filled-indigo-600 hover:bg-indigo-700"
            disabled={!title || !context}
            onClick={add}
          />
        </div>
      </Card>
    </>
  );
};
